<template>
    <div>
        <v-data-table
            dense
            :headers="checkheaders"
            :items.sync="checklist"
            :items-per-page="-1"
            :expanded.sync = "expanded"
            class="elevation-1"
            item-key="_id"
            sort-by="label"
        >
            <template v-slot:[`item.label`]="{ item }">
                <router-link v-if="showLink(item)" :to="{ name: 'check status report', params: { uuid: item.uuid, cid: item._id }}">
                    {{item.label}}
                </router-link>
                <span v-else>
                    {{ item.label }}
                </span>
            </template>
            <template v-slot:[`item.state`]="{ item }">
                <div style="min-width:48px">
                    <v-icon v-if="item.status === 'inactive' " large color="gray ">{{ iconName('job_disabled') }}</v-icon>
                    <v-icon v-else-if="item.status === 'up'|| item.status === 'not running'" large color="green darken-2">{{ iconName('job_up') }}</v-icon>
                    <v-icon v-else large color="red darken-2">{{ iconName('job_down') }}</v-icon>
                </div>
            </template>
            <template v-slot:[`item.thirtydays`]="{ item }">
                <div class='thirtydays'> {{item.thirtydays}} </div>
            </template>
            <template v-slot:expanded-item="{ headers, item }" >
                <td :colspan="headers.length">
                    <v-row v-if="showConfig && showCheckConfig === item._id">
                        <v-col class="flex-grow-1">
                            <h3>Editing {{ item._id }}</h3>
                            <v-text-field name="checklabel" :value="(item.report && item.report.label) || ''" label="Custom Check Label" @input="setField($event, 'label', item)"></v-text-field>
                        </v-col>
                        <v-col class="checkbuttons flex-shrink-1">
                            <v-btn color="secondary" class="elevation-1 mr-1" dark small @click="cancelChange(item)">
                                Cancel
                                <v-icon dark right>{{ iconName('cancel') }}</v-icon>
                            </v-btn>
                            <v-btn color="warning" class="elevation-1" dark small @click="saveCheckConfig(item._id), showCheckConfig = false">
                                Save Changes
                                <v-icon dark right>{{ iconName('remove') }}</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else-if="showConfig && confirmRemoveCheck === item._id">
                        <v-col class="flex-grow-1">
                            <strong>Confirm Removal of {{ item._id }}</strong>
                        </v-col>
                        <v-col class="checkbuttons flex-shrink-1">
                            <v-btn color="secondary" class="elevation-1 mr-1" dark small @click="cancelChange(item)">
                                Cancel
                                <v-icon dark right>{{ iconName('cancel') }}</v-icon>
                            </v-btn>
                            <v-btn color="warning" class="elevation-1" dark small @click="removeCheck(item._id)">
                                Confirm Removal
                                <v-icon dark right>{{ iconName('remove') }}</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else-if="showConfig">
                        <v-col class="flex-grow-1">
                            {{ item.description }}
                        </v-col>
                        <v-col class="checkbuttons flex-shrink-1">
                            <v-btn color="primary" class="elevation-1 mr-1" dark small @click="showCheckConfig = item._id, confirmRemoveCheck = false">
                                Edit Report Settings
                                <v-icon dark right>{{ iconName('edit') }}</v-icon>
                            </v-btn>
                            <v-btn v-if="reports_statusevents.reportConfig && !reports_statusevents.reportConfig.includeallchecks" color="secondary" class="elevation-1" dark small @click="confirmRemoveCheck = item._id, showCheckConfig = false">
                                Remove from Report
                                <v-icon dark right>{{ iconName('remove') }}</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <div v-else>
                        {{ item.description }}
                    </div>

                </td>
            </template>
            <template v-slot:[`item.expand`]="{ item }">
                <v-icon right @click="toggleDrawer(item)" v-if="item.expand && !expanded.includes(item)">{{ getIcon('open') }}</v-icon>
                <v-icon right @click="toggleDrawer()" v-if="item.expand && expanded.includes(item)">{{ getIcon('close') }}</v-icon>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import appconfig from "../config/shared";
import { mapState } from "vuex";
import { format as date_format, parse as date_parse, subDays } from "date-fns";
import { formatDay } from "../lib/filter";

export default {
    name: "Reports_Statusevents_Checkstatus_Table",
    props: {
        showConfig: {
            type: Boolean,
            default: false
        },
        availablemetrics: {
            type: Array
        }
    },
    data () {
        return {
            expanded: [],
            showCheckConfig: false,
            confirmRemoveCheck: false,
            customCheckSettings: {}
        };
    },
    computed: {
        ...mapState(["currentUser", "checks", "reports_statusevents", "now"]),
        checkheaders: function(){
            var headers = [
                {
                    text: "Check",
                    align: "start",
                    sortable: true,
                    value: "label",
                    show: true
                }
            ];
            if(this.reports_statusevents.reportConfig && (this.reports_statusevents.reportConfig.showdescription || this.showConfig )){
                headers.push({
                    text: '',
                    value: 'expand',
                    align: 'end',
                    sortable: false
                });
            }
            if(this.reports_statusevents.reportConfig && this.reports_statusevents.reportConfig.showtype){
                headers.push({
                    text: "Type",
                    align: "start",
                    sortable: true,
                    value: "type",
                    show: true
                });
            }
            headers.push({
                    text: "State",
                    align: "start",
                    sortable: true,
                    value: "state",
                    show: true
            });
            if(this.reports_statusevents.reportConfig && !this.reports_statusevents.reportConfig.hidecheckuptime){
                var week = this.sevenDays() || {};
                var count = 0;
                if(this.reports_statusevents.reportConfig.displaymetric === 'Uptime for seven days'){
                    for(let i in week){
                        headers.push({
                            text: formatDay(week[i]),
                            align: "end",
                            sortable: true,
                            value: "uptimeday-"+count,
                            show: true
                        });
                        count++;
                    }
                } else if(this.reports_statusevents.reportConfig.displaymetric === 'Uptime for seven and 30 days'){
                    for(let i in week){
                        let day = formatDay(week[i])
                        headers.push({
                            text: day,
                            align: "end",
                            sortable: true,
                            value: "uptimeday-"+count,
                            show: true
                        });
                        count++;
                    }
                    headers.push({
                        text: "30 Days",
                        align: "end",
                        sortable: true,
                        value: "thirtydays",
                        class: "thirtydays",
                        show: true
                    });

                } else if (this.reports_statusevents.reportConfig.displaymetric === 'Current response time'){
                    headers.push({
                        text: "Current Response Time (ms)",
                        align: "end",
                        sortable: true,
                        value: "result.rt",
                        show: true
                    })
                } else {
                    headers.push({
                        text: "Today's Uptime",
                        align: "end",
                        sortable: true,
                        value: "uptimeday-0",
                        show: true
                    });
                    headers.push({
                        text: "30 Days",
                        align: "end",
                        sortable: true,
                        value: "thirtydays",
                        class: "thirtydays",
                        show: true
                    });
                }
                // headers.push(...uptimeheaders);
                // console.log('building headers', week, count);
            }
            // console.log('building headers', headers);
            return headers;
        },
        checklist: function(){
            let list =  [];
            let idx = this.reports_statusevents.reportChecks.length;
            let week = this.sevenDays() || {};
            let i = 0;
            while( idx-- ){
                if(
                    !this.reports_statusevents.reportChecks[idx] ||
                    (this.reports_statusevents.reportConfig.hideupchecks && this.reports_statusevents.reportChecks[idx].status === 'up') ||
                    (this.reports_statusevents.reportConfig.hidedisabledchecks && this.reports_statusevents.reportChecks[idx].status === 'inactive') ||
                    (this.reports_statusevents.reportConfig.hidedownchecks && this.reports_statusevents.reportChecks[idx].status === 'down')
                ) {
                    // console.log("skipping", idx, i);
                    continue;
                }
                // console.log('adding', idx, i);
                let customCheckSettings = (this.customCheckSettings && this.customCheckSettings[this.reports_statusevents.reportChecks[idx]]) || undefined;

                list[i] = Object.assign({}, this.reports_statusevents.reportChecks[idx], customCheckSettings);

                list[i].label = (list[i].report && list[i].report.label) ||          // custom label set for the check on this report.
                    list[i].label ||                                // the job's label
                    list[i].params_target ||                        // this is how we get it from the server
                   (list[i].parameters && list[i].parameters.target) || // checks added locally before server refresh
                    list[i]._id;                                    // fallback, should always exist
                list[i].uptime = list[i].uptime || {};
                for(let d in week){
                    list[i]['uptimeday-'+ d ] = (list[i].uptime[week[d]] && (list[i].uptime[week[d]].uptime || list[i].uptime[week[d]].uptime === 0)) ? list[i].uptime[week[d]].uptime : '-';
                }
                list[i].result = list[i].result || {};
                list[i].result.rt = list[i].result.rt || '-';
                list[i].thirtydays = (list[i].uptime.total && (list[i].uptime.total.uptime || list[i].uptime.total.uptime === 0)) ?  list[i].uptime.total.uptime : '-';
                list[i].expand = this.showConfig || (this.reports_statusevents.reportConfig.showdescription && list[i].description && list[i].description.length);

                i++;
            }
            return list;
        }
    },
    methods: {
        removeCheck: function (val) {
            console.log('removeCheck', val);
            this.$store.dispatch('reports_statusevents/removeReportCheck', val);
        },
        cancelChange: function (val) {
            if(val && val._id && this.customCheckSettings && this.customCheckSettings[val._id]) delete this.customCheckSettings[val._id];
            this.showCheckConfig = false;
            this.confirmRemoveCheck = false;
        },
        saveCheckConfig: function (val) {
            console.log('saveCheckConfig', val, this.customCheckSettings[val]);
            const timestamp =  Date.now().toString(36);

            if (!this.customCheckSettings[val]) return;

            let record = {
                checkid: val,
                setCheck: Object.assign({ checkid: val }, this.customCheckSettings[val])
            };

            // for(let field in this.customCheckSettings[val]){
            //     console.log('saveCheckConfig setting', field, 'to', this.customCheckSettings[val][field]);
            //     this.job[field] = this.customCheckSettings[val][field];
            // }

            /*
                setCheck: {checkid: "201709282120FOZSE-LYOOZ87Y", label: "PUSH check test with no results!", order: 0}
            */

            this.$store.dispatch('setAlert', {message: "Saving check", key: timestamp, type: "info"})
            this.$store.dispatch('reports_statusevents/setReportCheck', record)
                .then( () => {
                    this.$store.dispatch('setAlert', {message: "Check Saved", key: timestamp, type: "success"})
                    this.$forceUpdate();
                })
                .catch( (e) => {
                    this.$store.dispatch('setAlert', {message: "Error Saving Check Information", key: timestamp, type: "error"})
                    console.log("error saving config update");
                });
        },
        /**
         * This method sets local state only.  It does not dispatch to the store.
         * The check information is sent to the store when the user clicks save (calling saveCheckConfig).
        */
        setField: function (val, field, job) {
            this.customCheckSettings[job._id] = this.customCheckSettings[job._id] || {};
            this.customCheckSettings[job._id][field] = val;
            console.log('setField', field, val)
            // this.job.report[field] = val;
        },
        iconName: function ( val ) {
            return appconfig.icons[val] || val;
        },
        showLink: function ( job ) {
            return this.reports_statusevents.reportConfig.showlinks && (this.reports_statusevents.reportConfig.showConfig || job.public);
        },
        /**
         * return array of dates
         * Array[7]
            0:"2020-11-12"
            1:"2020-11-11"
            2:"2020-11-10"
            3:"2020-11-09"
            4:"2020-11-08"
            5:"2020-11-07"
            6:"2020-11-06"
         */
        sevenDays: function () {
            if (!this.now) return {};
            let days = [this.now.date];
            let dateobj = date_parse(this.now.date);
            for (let i = 1; i < 7; i++) {
                days.push(date_format(subDays(dateobj, i), "YYYY-MM-DD")); // we need this format to use the uptime data
            }
            return days;
        },
        getIcon: function ( val ) {
            return appconfig.icons[val] || val;
        },
        toggleDrawer: function ( job ) {
            job = job || undefined;
            // this.$root.$set(this.expanded, (job && [job]) || []);
            if(job){
                this.expanded =  [job];
            } else {
                this.expanded.splice(0);
            }

        }

    }
};
</script>

<style>
.v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
    box-shadow: none;
    -webkit-box-shadow: none;
    line-height: 1.8em;
}

.checkbuttons {
    max-width: 220px;
    width: 220px;
}

</style>